Object.defineProperty(exports, "__esModule", { value: true });
exports.basicClasses = {
    container: {
        position: 'relative',
        width: 60,
        height: 60,
        borderRadius: '50%',
        padding: 4,
        backgroundClip: 'content-box'
    },
    '@keyframes StatusLogo-pulsationAnimation': {
        '0%': 'box-shadow: 0 0 0 0px currentColor',
        '50%': 'box-shadow: 0 0 0 8px currentColor',
        '100%': 'box-shadow: 0 0 0 4px currentColor'
    }
};
